import BaseReducer from "./BaseReducer";
import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "@common/components/helpers/datetime";

class SuspiciousActivityReducer extends BaseReducer {
  domain = "SuspiciousActivity";
  type = "View";

  initialState = {
    showSuspectModal: false,
    types: [],
    suspectsTable: [],
    searchedCustomer: null,
    complianceAlertId: null,
    formData: {
      id: null,
      date: getDatePart(getCurrentDateTime()),
      time: getTimePart(getCurrentDateTime()),
      activityType: null,
      sessionGuids: [],
      machine: null,
      machineReference: null,
      cctvCatched: null,
      description: "",
      outcome: "",
      customerIds: [],
      customers: [],
      policedInvolved: null,
      timeServicesContacted: getTimePart(getCurrentDateTime()),
      timeServicesArrived: getTimePart(getCurrentDateTime()),
      servicesDidNotAttend: false,
      incidentNumber: null,
    },
  };
}

const reducer = new SuspiciousActivityReducer();

export default reducer;
